import React from 'react';
import { Card, CardContent, Typography, Button, Box } from '@mui/material';

interface SingleStoryPurchaseCardProps {
  onSelect: () => void;
  isSelected: boolean;
}

const SingleStoryPurchaseCard: React.FC<SingleStoryPurchaseCardProps> = ({ onSelect, isSelected }) => {
  return (
    <Card
      onClick={onSelect}
      variant='outlined'
      sx={{
        textAlign: 'left',
        minWidth: '250px',
        borderRadius: '24px',
        padding: '10px',
        display: 'flex',
        flexDirection: 'column',
        border: isSelected ? '2px solid #0072CE' : undefined,
      }}
    >
      <CardContent sx={{ flexGrow: 1 }}>
        <Box sx={{ borderColor: '#CCCCCC' }}>
          <Typography
            sx={{
              backgroundColor: 'var(--light-pink)',
              color: 'var(--dark-purple)',
              borderRadius: '24px',
              marginBottom: '12px',
              padding: '8px 16px',
              fontFamily: 'DM Sans, sans-serif',
              fontSize: '13px',
              display: 'inline-block',
            }}
          >
            Single Story Purchase
          </Typography>

          <Typography sx={{ color: 'inherit' }}>
            <Typography
              sx={{
                color: 'var(--dark-blue)',
                fontFamily: 'DM Sans, sans-serif',
                fontSize: '26px',
                lineHeight: '150%',
              }}
            >
              $99 <Typography component="span" sx={{ fontSize: '16px', color: '#666' }}>one-time</Typography>
            </Typography>
          </Typography>
        </Box>

        <Typography sx={{ color: 'inherit', mt: 2 }}>
          <div className='pricing-description'>
            <ul style={{ paddingLeft: '20px', margin: '8px 0' }}>
              <li>Create <strong>1 Memvy</strong></li>
              <li><strong>50GB</strong> of storage</li>
              <li>Valid for <strong>5 years</strong></li>
              <li>One-time payment, no recurring fees</li>
            </ul>
          </div>
        </Typography>
      </CardContent>

      <Box display='flex' alignItems='center' justifyContent='center' sx={{ paddingBottom: '1rem', marginTop: 'auto' }}>
        <Button
          sx={{
            bgcolor: '#0072CE',
            height: '3.18rem',
            width: '12.75rem',
            borderRadius: '12.5rem',
            '&:hover': {
              bgcolor: '#0072CE',
            },
          }}
        >
          <Typography color='#fff' variant='button'>
            Choose plan
          </Typography>
        </Button>
      </Box>
    </Card>
  );
};

export default SingleStoryPurchaseCard;
